import React, {Component, PropTypes} from 'react'

export class ProfileCard extends Component {

  static propTypes = { profile: PropTypes.object.isRequired }

  render () {
    const {profile} = this.props;
    return (
      <div className='profile card'>
        <div className='profile__cover-image' style={{backgroundImage: `url(${profile.coverImage})`}}>
          <div
            className='profile__avatar'
            style={{backgroundImage: profile.avatarUrl && 'url('+profile.avatarUrl+')'}}
          />
          <div className='card__name'>
            {profile.name}
          </div>
        </div>
        <div className='card__caption'>
          {profile.location}
        </div>
        <p className='card__description'>
          {profile.description}
        </p>
      </div>
    );
  }
}
